<template>
  <div class="header">
    <div class="icon" @click="back"><van-icon name="arrow-left" size="16px" /></div>
    <div class="title"><slot></slot></div>
    <div class="wallet" @click="login">
      <img src="/transaction/wallet.png" />
      <span v-if="!info">{{ $t('transaction.wallet') }}</span>
      <span v-else>{{ info | filterInfo(false) }}</span>
    </div>
  </div>
</template>

<script>
import { BrowserProvider } from 'ethers'
import { postAction, syncPostAction } from '@/api/manage'
import Web3 from 'web3'

let provider = null
let web3 = null

function getProvider() {
  if (!provider && window.ethereum) {
    provider = new BrowserProvider(window.ethereum)
  }
  return provider
}

function getWeb3() {
  if (!web3 && window.ethereum) {
    web3 = new Web3(window.ethereum)
  }
  return web3
}

export default {
  data() {
    return {
      info: '', 
    }
  },
  filters: {
    filterInfo(n, long) {
      if (n == '' || n == null) {
        return
      }
      let reg
      if (long) {
        reg = /^(\w{12})\w+(\w{8})$/
        return n.replace(reg, '$1......$2')
      } else {
        reg = /^(\w{4})\w+(\w{4})$/
        return n.replace(reg, '$1...$2')
      }
    },
  },
  mounted() {
    this.userInfo()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    userInfo() {
      postAction('/api/users/info').then(res => {
        if (res.data.code == 401) {
          this.login()
        } else {
          this.info = res.data.data.address
          this.$emit('login', this.info)
          localStorage.setItem('userInfo', this.info)
        }
      })
    },
    async getNetworkId() {
      const web3Instance = getWeb3()
      if (!web3Instance) return null
      const currentChainId = await web3Instance.eth.net.getId()
      return currentChainId
    },
    async swichNetwork(chainId) {
      const currentChainId = await this.getNetworkId()

      if (currentChainId !== chainId) {
        const web3Instance = getWeb3()
        if (!web3Instance) return
        try {
          await web3Instance.currentProvider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: Web3.utils.toHex(chainId) }],
          })
        } catch (switchError) {
          if (switchError.code === 4902) {
            alert('Place Add BNB Smart Chain Mainnet')
          }
        }
      }
    },
    async login() {
      if (!window.ethereum) {
        alert('Please install MetaMask or another Web3 wallet')
        return
      }

      await this.swichNetwork(process.env.VUE_APP_NETWORK_ID)

      const providerInstance = getProvider()
      if (!providerInstance) return

      const signer = await providerInstance.getSigner()
      let { chainId } = await providerInstance.getNetwork()

      let param1 = new FormData()
      param1.append('address', signer.address)
      param1.append('chainId', chainId)
      let message
      await syncPostAction('/api/sessions/message', param1).then(res => {
        message = res.data
      })

      let param = new FormData()
      param.append('signature', await signer.signMessage(message))
      await syncPostAction('/api/sessions/sign_in', param).then(res => {})
      this.userInfo()
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  padding-top: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    font-family: 'PingFang TC';
    font-weight: 600;
    font-size: 16px;
    text-align: center;
  }
  .icon {
    width: 60px;
  }

  .wallet {
    height: 23px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #292929;
    border-radius: 4px;

    img {
      width: 13px;
      height: 13px;
      margin-right: 8px;
    }
  }
}
</style>
